import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getProjectsForUser = api(async function getProjectsForUser({ userId } = {}) {
    return query(
        gql`
            query GetProjectsForUser($userId: String!) {
                getProjectsForUser(userId: $userId)
            }
        `,
        { userId },
        { returns: "getProjectsForUser" }
    )
})
